export default __webpack_public_path__ + "static/media/mapJPEG.84f08460.jpg";